import React from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation, Trans} from "react-i18next";
import {Button} from "../../Widgets/Button/Button";
import {AccountSettings} from "../../Widgets/AccountSettings/AccountSettings";
import {ACCOUNT_ROUTE, SIGN_IN_ROUTE} from "../../../routes";
import {useEmailLinkLanguage} from "../useEmailLinkLanguage";

function DeleteAccount() {
    const {t} = useTranslation();
    const history = useNavigate();
    useEmailLinkLanguage();

    const handleSignInClick = () => {
        history(ACCOUNT_ROUTE + SIGN_IN_ROUTE, {replace: true});
    };

    return (
        <div className="window-modal-container">
            <div className="window-modal">
                <div className="window-modal-title disable-select pb-4 d-flex justify-content-center">
                    Binora
                </div>
                <div className="window-modal-title disable-select pb-2 d-flex justify-content-center">
                    {t("delete_account_public_title")}
                </div>
                <div className="window-modal-text my-2">
                    <Trans
                        i18nKey="delete_account_public_description"
                        components={{bold: <strong/>}}
                    />
                </div>
                <div className="d-flex justify-content-center">
                    <div className="window-modal-button">
                        <Button className="mt-4" text={t("sign_in")} highlighted={true} onClick={handleSignInClick}/>
                    </div>
                </div>
                <div className="mt-4"/>
                <AccountSettings/>
            </div>
        </div>
    );
}

export default DeleteAccount;
